import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, applicationsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, applicationsActions);

export default slice.reducer;
